export const READER_ENV = (window.location.origin.split("").reverse().join("") === "oc.moc.ekamekam//:sptth" || window.location.origin === 'https://makemake.com.co')?'production':'development';
/**
 * Prefijo que se pone anterior al nombre del evento que se envia como mensaje a esta ventana o al contenedor de este lector.
 */
export const READER_MESSAGE_EVENT_PREFIX = "MAKEMAKE_READER_EVENT:";
/**
 * Nombre de los eventos disponibles para enviar.
 */
export const READER_MESSAGE_EVENTS_TO_RECEIVE = {
	ASYNC_STATS: "ASYNC_STATS",
	ACTIVITY_CLICK: "ACTIVITY_CLICK",
	SHARE_CLICK: "SHARE_CLICK",
	RECOMMENDED_LINK_CLICK: "RECOMMENDED_LINK_CLICK",
};
/**
 * Nombre de los eventos disponibles para enviar.
 */
export const READER_MESSAGE_EVENTS_TO_SEND = {
	DOWNLOADED_IN_APP: "DOWNLOADED_IN_APP",
	NETWORK_STATUS_CHANGES:'NETWORK_STATUS_CHANGES'
};

export const AVAILABLE_LANGUAGES = {
	en: "en",
	es: "es",
};

export const AVAILABLE_LANGUAGES_ARRAY = Object.values(AVAILABLE_LANGUAGES);

/**
 * Keys que se usan para guardar información en el storage, acá deben ir plasmadas todas las keys que se usen para guardar info.
 */
export const STORAGE_KEYS = {
	favorite_books_ids: "favorite_books_ids",
	seen_notifications: "SEEN_NOTIFICATIONS",
	tour_collection: "tourCollection",
	credentials: "credentials",
	bookmarks: 'MAKEMAKE_READER_BOOKMARKS'
}

/**
 * Aqui estan las keys que no deberían  borrarse del storage cuando se cierre la sesión
 */
export const IMPORTANT_STORAGE_KEYS = [
	STORAGE_KEYS.tour_collection,
	STORAGE_KEYS.favorite_books_ids,
	STORAGE_KEYS.seen_notifications,
	STORAGE_KEYS.credentials,
	STORAGE_KEYS.bookmarks
];
